import React from 'react';
import HuaweiIcon from "../../assets/img/HuaweiIcon.svg";
import AppStoreIcon from "../../assets/img/AppstoreIcon.svg";
import PlayStoreIcon from '../../assets/img/GooglePlayIcon.svg';

const DownloadApps = (props) => {

    return (
        <div className={props.classes}>
            {props.info ? <div className={`${props.classes}-label`}>{props.info}</div> : ""}
            <div className={`${props.classes}-container`}>
                {props.google_play_link &&
                    <a
                        href={props.google_play_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={PlayStoreIcon} alt="Play Store" />
                    </a>
                }
                {props.app_store_link &&
                    <a
                        href={props.app_store_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={AppStoreIcon} alt="App Store" />
                    </a>
                }
                {props.app_store_link &&
                    <a
                        href={props.huawei_store_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={HuaweiIcon} alt="Huawei" />
                    </a>
                }
                {props.children}
            </div >
        </div>
    );
}

export default DownloadApps;